export default __webpack_public_path__ + "static/media/Progression2.8a9ac2fb.png";